import React, { SVGProps } from "react";

export default function SupBridge(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M12.5466 6.0895C11.7645 5.75616 10.9038 5.5717 10 5.5717C6.4836 5.5717 3.62698 8.40457 3.50412 11.8836C2.63942 12.1042 2 12.8883 2 13.8217C2 14.9263 2.89543 15.8217 4 15.8217C5.10457 15.8217 6 14.9263 6 13.8217C6 12.8915 5.36496 12.1096 4.50476 11.8859C4.62595 8.94888 7.04451 6.5717 10 6.5717C10.7664 6.5717 11.4963 6.72847 12.1591 7.01169L10.3562 7.49477L10.6151 8.4607L13.3679 7.72309C14.6194 8.69376 15.4406 10.1928 15.4969 11.8855C14.6359 12.1086 14 12.8909 14 13.8217C14 14.9263 14.8954 15.8217 16 15.8217C17.1046 15.8217 18 14.9263 18 13.8217C18 12.8888 17.3613 12.1051 16.4973 11.884C16.4375 9.77294 15.3711 7.91382 13.761 6.76968L13.091 4.17834L12.1229 4.42866L12.5237 5.97899L12.5466 6.0895Z"
        fill="currentColor"
      />
    </svg>
  );
}
